import { useCreateCFWorkerWebsiteMutation } from "../services/websiteUrlApiSlice";
import { ICreateCFWorkerWebsiteReq } from "../types";

interface UseSubmitWebDemoProps {
    data: ICreateCFWorkerWebsiteReq;
}

const useSubmitWebDemo = ({ data }: UseSubmitWebDemoProps) => {
    const [createCFWorkerWebsite, { isLoading, isSuccess, isError, error, data: responseData, reset }] =
        useCreateCFWorkerWebsiteMutation();

    const handleSubmit = async () => {
        if (!data.siteTitle || !data.amazeMode || !data.amazeKey) {
            return;
        }
        await createCFWorkerWebsite(data);
    };

    return {
        handleSubmit,
        isLoading,
        isSuccess,
        isError,
        error,
        responseData,
        reset,
    };
};

export default useSubmitWebDemo;
